var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{attrs:{"id":"app-loader"}},[_c('img',{staticClass:"img-fluid loader",attrs:{"src":require("@/assets/images/b2b/icon.png"),"alt":"","width":"200","height":"200"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }